/**
 * RAM — BackOnTrack action.
 *
 * Placeholder — final spec pending Collette clarification.
 * Per procedures digest §RAM:
 *   "Back-on-Track: label as TODO; backend semantics still being defined."
 */
import { Banner, Button, Pill } from '@/components/primitives';
import type { RamTarget } from '../types';

export interface BackOnTrackProps {
  target: RamTarget;
  onDone: () => void;
  onCancel: () => void;
}

export default function BackOnTrack({
  target,
  onCancel,
}: BackOnTrackProps): JSX.Element {
  return (
    <div className="ram-wizard">
      <div className="ram-wizard__header">
        <h2 className="ram-wizard__title">Back on Track</h2>
        <Pill variant="warn">Pending clarification</Pill>
      </div>

      <Banner tone="warn">
        The Back-on-Track customer-assistance enrollment is still being defined
        by Collette. This surface will be completed once the backend semantics
        land. For now, escalate manually and capture a TaskRecord.
      </Banner>

      <div style={{ fontSize: 12, color: 'var(--ink-600)' }}>
        CIF <code>{target.cifId}</code>
        {target.acctId && (
          <>
            &nbsp;·&nbsp;Account <code>{target.acctId}</code>
          </>
        )}
      </div>

      <div className="ram-wizard__actions">
        <Button variant="ghost" onClick={onCancel}>
          Back to actions
        </Button>
      </div>
    </div>
  );
}
